/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkSubSup from '@uplight/remark-sub-sup';
import remarkShortCode from '@uplight/remark-shortcode';
import MarkdownLinkRenderer from './MarkdownLinkRenderer';
import MarketplaceShortcodes from './MarketplaceShortcodes';
import fragmentWrapperRenderer from './fragmentWrapperRenderer';


const CustomReactMarkdown = ({
  className,
  linkActions,
  linkMeta,
  source,
  renderers,
  tooltip,
  noWrapper,
  styleFlag,
}) => {
  let renderersCopy = renderers;

  if (noWrapper) {
    renderersCopy = {
      ...fragmentWrapperRenderer,
      ...renderers,
    };
  }

  const raiseLinkActions = linkActions ?
    (hooks) => {
      (['*', ...hooks])
        .filter(hook => linkActions[hook] instanceof Function)
        .forEach(hook => linkActions[hook]());
    } :
    null;

  let parsedSource = source;

  if (linkMeta && parsedSource) {
    const markdownLinkPattern = /\[([^[]+)\]\(([^(]+)\)/gi;

    const addLinkMetadata = (_match, label, href) => {
      const parsedHref = linkMeta.reduce(
        (href, meta) => (href.includes(`{${meta}}`) ? href : `${href}{${meta}}`),
        href,
      );

      return `[${label}](${parsedHref})`;
    };

    parsedSource = parsedSource.replace(markdownLinkPattern, addLinkMetadata);
  }

  return (
    <ReactMarkdown
      className={`custom-react-markdown${className ? ` ${className}` : ''}`}
      source={parsedSource}
      plugins={[remarkShortCode, remarkSubSup]}
      renderers={{
        link: props => <MarkdownLinkRenderer {...props} action={raiseLinkActions} />,
        shortcode: props => (
          <MarketplaceShortcodes
            {...props}
            styleFlag={styleFlag}
            tooltip={tooltip}
          />
        ),
        sub: 'sub',
        sup: 'sup',
        ...renderersCopy,
      }}
    />
  );
};

CustomReactMarkdown.propTypes = {
  className: PropTypes.string,
  linkActions: PropTypes.objectOf(PropTypes.func),
  linkMeta: PropTypes.arrayOf(PropTypes.string),
  source: PropTypes.string.isRequired,
  renderers: PropTypes.shape({}),
  tooltip: PropTypes.shape({}),
  noWrapper: PropTypes.bool,
  styleFlag: PropTypes.string,
};

CustomReactMarkdown.defaultProps = {
  className: null,
  linkActions: null,
  linkMeta: null,
  renderers: {},
  tooltip: null,
  noWrapper: false,
  styleFlag: 'inline',
};

export default CustomReactMarkdown;
